import React, { ReactElement } from "react";
import * as app from '../services/AppService'
//@ts-ignore
import  bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js' 
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface DropdownProps extends RowItem, InterfaceComponentsProps {
    options?: any[],
    data?: any[],
    itemClass?: string,
    placeholder?: string,
    value?: string,
    elmKey?: string | number,
    isTable?: boolean,
    autoClose?: string,
    sNclicked?:(...args:any) => any
    children?: ReactElement[] | any
}

function DropdownButton(props: DropdownProps) {

    function closeMenu(e:React.MouseEvent<HTMLUListElement>) {
        //@ts-ignore
        if (e && e.target && e.target.classList && e.target.classList.contains("dropdown-item")) return;//اغلاق المنيو الا اذا كان الزر المضغوط لمينيو تاني
        let toggleBtn = document.getElementById((props.id ||"dropdown").toString())
        if (toggleBtn) {
            let dropdownEl = new bootstrap.Dropdown(toggleBtn);
            dropdownEl.hide();
        }
    }

    return (
        <div className={"btn-group " + props.class}>

            <button className={`btn btn-sm dropdown-toggle  ${props.labelClass}`} data-bs-auto-close={props.autoClose}
                data-bs-toggle="dropdown" aria-expanded="false" id={(props.id ||"dropdown").toString()}>
                {app.translate(props.label)}
                {props.icon && <span className={`iconssc-${props.icon}`}></span>}
            </button>

            <ul className={"dropdown-menu" + props.itemClass} aria-labelledby="dropdownMenuButton" onClick={closeMenu}>
                {props.children ?
                    Array.isArray(props.children) && props.children[0].type == "li" ? props.children:
                    <li>{props.children}</li>
                    :
                    props.options!.map((item, index) => {
                        return (
                            <li key={index}>
                                <button className="dropdown-item fw-bold" style={{ "fontSize": "12px" }} onClick={() => props.sNclicked!(item[props.elmKey!], props.data || [])}>
                                    {item[props.value!]}
                                </button>
                                <hr className="m-0 dropdown-divider" />
                            </li>

                        );
                    })
                }
            </ul>
        </div>
    )
}

DropdownButton.defaultProps = {
    options: [],
    data: [],
    disabled: false,
    label: '',
    class: '',
    labelClass: 'btn-primary ',
    itemClass: ' mx-1 p-1 ',
    value: "Value",
    elmKey: "Key",
    autoClose: "auto",
    table: false,
}
export default DropdownButton;